import { useModalState } from "@clipboard-health/ui-react";
import { CircularProgress, Tooltip } from "@mui/material";

import { Button } from "../../../components/Button";
import { useGetWorkerLockStatus } from "../api/useGetWorkerLockStatus";
import { TOOLTIP_TEXTS } from "../constants";
import { LockedByOtherDialog } from "./LockedByOtherDialog";
import { LockFlowDialog } from "./LockFlowDialog";
import { UnlockConfirmationDialog } from "./UnlockConfirmationDialog";

interface InHomeLockToggleProps {
  workerId: string;
  workplaceId: string;
}

export function InHomeLockToggle(props: InHomeLockToggleProps) {
  const { workerId, workplaceId } = props;

  const { isLoading, isLocked, lockedByCurrentWorkplace, lockData } = useGetWorkerLockStatus({
    workerId,
    workplaceId,
  });

  const lockFlowModalState = useModalState();
  const unlockModalState = useModalState();
  const lockedByOtherModalState = useModalState();

  if (isLoading) {
    return <CircularProgress size={20} />;
  }

  if (!isLocked) {
    return (
      <>
        <Tooltip title={TOOLTIP_TEXTS.lock}>
          <Button
            size="small"
            variant="primary"
            startIconType="padlock-locked"
            onClick={lockFlowModalState.openModal}
          >
            Lock
          </Button>
        </Tooltip>
        <LockFlowDialog
          modalState={lockFlowModalState}
          workerId={workerId}
          workplaceId={workplaceId}
        />
      </>
    );
  }

  if (lockedByCurrentWorkplace) {
    return (
      <>
        <Tooltip title={TOOLTIP_TEXTS.unlock}>
          <Button
            size="small"
            variant="outlined"
            startIconType="padlock-locked"
            onClick={unlockModalState.openModal}
          >
            Unlock
          </Button>
        </Tooltip>
        <UnlockConfirmationDialog
          modalState={unlockModalState}
          lockReason={lockData?.attributes.lockReason ?? ""}
          unlockCondition={lockData?.attributes.unlockCondition ?? ""}
          lockId={lockData?.id ?? ""}
          workplaceId={workplaceId}
        />
      </>
    );
  }

  return (
    <>
      <Tooltip title={TOOLTIP_TEXTS.lockedByOther}>
        <Button
          size="small"
          variant="danger"
          startIconType="padlock-locked"
          onClick={lockedByOtherModalState.openModal}
        >
          Locked
        </Button>
      </Tooltip>
      <LockedByOtherDialog modalState={lockedByOtherModalState} />
    </>
  );
}
